var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00CC5D",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    d: "M16.979 21.429a11.3 11.3 0 0 0-5.136-1.246c-1.667 0-3.263.372-4.735 1.052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#activity_svg__a)",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    d: "m11.91 16.423-5.393-3.138V4.83c0-.805.653-1.457 1.457-1.457h7.209"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    d: "m6.517 13.285 5.392 3.139 5.563-3.139v-1.514"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.604,
    d: "M7.86 3.373h8.28c.739 0 1.337.599 1.337 1.337v8.592l-5.57 3.096-5.384-3.09V4.71c0-.738.598-1.337 1.336-1.337Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.18 13.713a3.21 3.21 0 0 0 2.69-3.166V6.794c0-.59-.48-1.07-1.07-1.07h-1.62V7.3h.66c.295 0 .534.24.534.535v2.812c0 .59-.479 1.07-1.07 1.07h-.124zM4.82 13.713a3.21 3.21 0 0 1-2.69-3.166V6.794c0-.59.48-1.07 1.07-1.07h1.62V7.3h-.66a.535.535 0 0 0-.534.535v2.807c0 .59.479 1.07 1.07 1.07h.124z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "activity_svg__a",
    x1: 6.804,
    x2: 14.201,
    y1: 3.372,
    y2: 3.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111112"
  })))));
};
export default SvgActivity;